/* =========================================================================
   TimeFrameSupply - Shop the Look
   Custom element, registered once. Multiple instances per page are fine.
   ========================================================================= */

class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide-index]'));
    this.hotspots = Array.prototype.slice.call(this.querySelectorAll('[data-hotspot]'));
    this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-card]'));
    this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
    this.panel = this.querySelector('[data-panel]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.index = 0;

    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.go(self.index - 1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.go(self.index + 1);
      });
    }

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.go(i);
      });
    });

    this.hotspots.forEach(function (spot) {
      spot.addEventListener('click', function () {
        self.activate(spot.dataset.hotspot, true);
      });
      spot.addEventListener('mouseenter', function () {
        self.activate(spot.dataset.hotspot, false);
      });
      spot.addEventListener('focus', function () {
        self.activate(spot.dataset.hotspot, true);
      });
    });

    this.cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        self.activate(card.dataset.card, false);
      });
      card.addEventListener('focusin', function () {
        self.activate(card.dataset.card, false);
      });
      card.addEventListener('click', function () {
        self.activate(card.dataset.card, false);
      });
    });

    this.go(0);
  }

  go(next) {
    var total = this.slides.length || 1;
    this.index = ((next % total) + total) % total;
    var current = this.index;

    this.slides.forEach(function (slide, i) {
      slide.toggleAttribute('hidden', i !== current);
    });

    this.dots.forEach(function (dot, i) {
      var on = i === current;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });

    var firstOnSlide = null;
    this.cards.forEach(function (card) {
      var match = Number(card.dataset.slide) === current;
      card.toggleAttribute('hidden', !match);
      if (match && !firstOnSlide) firstOnSlide = card;
    });

    if (this.panel) this.panel.scrollLeft = 0;
    if (firstOnSlide) this.activate(firstOnSlide.dataset.card, false);
  }

  activate(id, bringIntoView) {
    this.hotspots.forEach(function (spot) {
      var on = spot.dataset.hotspot === id;
      spot.classList.toggle('is-active', on);
      spot.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var target = null;
    this.cards.forEach(function (card) {
      var on = card.dataset.card === id;
      card.classList.toggle('is-active', on);
      if (on) target = card;
    });

    if (
      bringIntoView &&
      target &&
      this.panel &&
      window.matchMedia('(max-width: 1099px)').matches
    ) {
      this.panel.scrollTo({
        left: target.offsetLeft - this.panel.offsetLeft,
        behavior: 'smooth'
      });
    }
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook);
}
